module.exports = __webpack_public_path__ + "static/fonts/CoTextCorp-Regular.548f9cb.woff";